import Image from 'next/image';
import cx from 'classnames';
import IconLogo from '@/components/_rebrand/IconLogo';
import FrontCompare, { FrontCompareProps } from '@/components/_rebrand/FrontCompare';
import { ReactElement, ReactNode } from 'react';
import { parseHtml } from '@/lib/parse-html';

const displayProps = {
  eyebrow: '',
  title: '',
  description: '',
  frontLogo:
    <IconLogo
      className={cx('w-full block text-black')}
    />,
  frontLogoMobile:
    <Image src="https://front.com/webassets/rebrand/front-logo-white.png" width={94} height={23} alt="Front logo" />,
  legacy: null,
  compare: [],
  customerQuote: {
    logo: null,
    quote: null,
    name: '',
    position: ''
  },
  styleOverrides: undefined,
} as FrontCompareProps;

interface QuoteImageLogoFromCraft {
    url: string;
    title: string;
    width: number;
    height: number;
}

interface QuoteFromCraft {
  imageLogo: QuoteImageLogoFromCraft[];
  quote: string;
  personRole: string;
}

interface FeatureFromCraft {
  featureLabel: string;
  frontFeature: boolean;
  competitorFeature: boolean;
}

interface ModuleProductCompetitiveTable {
  comparisonName: string;
  comparableFeatures: FeatureFromCraft[];
  eyebrowText: string;
  headline: string;
  description: string;
  quote: QuoteFromCraft;
  hideSection: boolean;
}

const stripLeadingParagraph = (element: ReactElement): ReactNode => {
  if (element.type === 'p') {
    return element.props.children;
  }
  return element;
};

const formCustomerQuote = (quote: QuoteFromCraft): FrontCompareProps['customerQuote'] => {
  const imageLogo = quote.imageLogo[0];
  const customerQuote: FrontCompareProps['customerQuote'] = {
    logo: imageLogo ? <Image src={imageLogo.url} width={imageLogo.width} height={imageLogo.height} style={{ width: 120}} alt={imageLogo.title} /> : null,
    quote: <span>“<span className="font-serif">{stripLeadingParagraph(parseHtml(quote.quote))}</span>”</span>,
    name:  parseHtml(quote.personRole),
    position: ``
  }

  return customerQuote;
}

const formLegacyText = (comparisonName: string): FrontCompareProps['legacy'] => {
  return <div className="w-full justify-center">{comparisonName}</div>
}

const formFeatureList = (features: FeatureFromCraft[]): FrontCompareProps['compare'] => {
  const featureList: FrontCompareProps['compare'] = features.map((feature) => ({
    feature: feature.featureLabel
  }));

  return featureList;
}

const setDynamicDisplayPropAttributes = (data: ModuleProductCompetitiveTable) => {
  displayProps.eyebrow = data.eyebrowText;
  displayProps.title = data.headline;
  displayProps.description = data.description;
  displayProps.customerQuote = formCustomerQuote(data.quote[0]);
  displayProps.compare = formFeatureList(data.comparableFeatures);
  displayProps.legacy = formLegacyText(data.comparisonName);
}

const CompetitiveTable = ({ entry }) => {
  const data = Array.isArray(entry?.moduleProductCompetitiveTable)
    ? entry.moduleProductCompetitiveTable[0]
    : entry?.moduleProductCompetitiveTable;

  setDynamicDisplayPropAttributes(data);
  displayProps.backgroundColor = entry.moduleProductTheme[0].color;

  if (data.hideSection) {
    return null;
  }

  const isRebrandModule = (data.__typename && (data.__typename == 'comparisonModules_competitiveTable_BlockType'));

  if (isRebrandModule) {
    displayProps.styleOverrides = {
      bottomMarginSpacing: 'none',
      topMarginSpacing: 'none'
    };
  }

  return (

    <div className={`${isRebrandModule ? `bg-violet-100 pt-2 border-[rgb(248,241,254)]` :  `bg-transparent`}`}
      >
      <FrontCompare {...displayProps} />
    </div>
  );
};

export default CompetitiveTable;

